<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position: relative">
      <div style="display: flex; align-items: center">
        <span
          ><v-btn
            icon
            color="primary"
            to="/weserve_admin_login/-/reportdashboard/main"
            class="pa-4"
          >
            <v-icon color="black">arrow_back</v-icon></v-btn
          ></span
        >
        <span class="main-title">MAIN DASHBOARD | &nbsp;</span>
        <span class="submain-title">Order Dine in Report</span>
      </div>
    </div>
    <v-form v-model="valid" ref="searchForm">
      <v-card dark style="border-radius: 10px">
        <v-layout justify-space-between row wrap class="pa-3">
          <v-flex s12 sm3 class="pl-2">
            <v-select
              label="Status"
              item-text="name"
              item-value="value"
              :items="[
                { name: 'Completed', value: '3' },
                { name: 'Canceled', value: '4' },
              ]"
              v-model="form.order_status"
              :rules="[(v) => !!v || 'required']"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="pl-2">
            <v-menu
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="-30"
              lazy
              transition="scale-transition"
              offset-y
              style="width: 100%"
            >
              <v-text-field
                label="Start"
                slot="activator"
                prepend-icon="event"
                readonly
                v-model="form.datetime_start"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
              <v-date-picker
                color="#333"
                no-title
                @input="
                  menu1 = false;
                  form.datetime_start = $event;
                "
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 class="pl-2">
            <v-menu
              :close-on-content-click="false"
              v-model="menu2"
              :nudge-right="-30"
              lazy
              transition="scale-transition"
              offset-y
              style="width: 100%"
            >
              <v-text-field
                label="End"
                slot="activator"
                prepend-icon="event"
                readonly
                v-model="form.datetime_end"
                :rules="[
                  (v) => !!v || 'required',
                  (v) =>
                    v >= form.datetime_start ||
                    'End date must more than start date',
                ]"
              ></v-text-field>
              <v-date-picker
                :min="moment(form.datetime_start).format('YYYY-MM-DD')"
                color="#333"
                no-title
                @input="
                  menu2 = false;
                  form.datetime_end = $event;
                "
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex
            xs12
            sm2
            style="display: flex; justify-content: center; align-items: center"
          >
            <div class="pt-2 text-xs-center search-btn" @click="search()">
              <v-progress-circular
                indeterminate
                color="black"
                v-if="searching"
              ></v-progress-circular>
              <v-icon large color="black" v-else>search</v-icon>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
    <v-layout wrap row class="mt-3" v-if="dineinOrderReport.length > 0">
      <v-flex xs5 sm4 class="ml-1">
        <v-select
          :items="columnItems"
          item-value="value"
          v-model="sortColumn"
          @change="letSortBy()"
          label="Sort by"
          color="black"
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs2 sm1>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sortColumn != undefined && sortBy == 'asc'"
          :disabled="sortBy == 'desc' || sortColumn == undefined"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sortColumn != undefined && sortBy == 'desc'"
          :disabled="sortBy == 'asc' || sortColumn == undefined"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>

      <v-flex style="display: flex; align-items: center">
        <v-spacer></v-spacer>
        <div style="display: flex; justify-content: flex-end">
          <download-excel
            :data="dineinOrderReport"
            :fields="{
              'Order code': 'order_code',
              Customer: 'order_customer_full_name',
              Status: {
                field: 'order_status',
                callback: (value) => {
                  return value == 3
                    ? 'Completed'
                    : value == 4
                    ? 'Canceled'
                    : '';
                },
              },
              'Net price (THB)': 'order_net_price',
              'Payment type': {
                field: 'order_payment_type',
                callback: (value) => {
                  return value == 5
                    ? 'QR code'
                    : value == 2
                    ? 'Credit/Debit Card'
                    : '';
                },
              },
              'Datetime order': 'create_at',
              'Datetime dine in': 'order_booking_datetime',
              'Store name': 'order_store.store_name',
              'Store Tel.': 'order_store.store_tel',
            }"
            :name="
              'OrderDineIn_' +
              $route.query.datetime_start +
              '_to_' +
              $route.query.datetime_end +
              '.csv'
            "
            style="margin-right: 50px"
          >
            <v-btn icon> <v-icon large color="black">print</v-icon>.xls </v-btn>
          </download-excel>

          <download-excel
            type="csv"
            :data="dineinOrderReport"
            :fields="{
              'Order code': 'order_code',
              Customer: 'order_customer_full_name',
              Status: {
                field: 'order_status',
                callback: (value) => {
                  return value == 3
                    ? 'Completed'
                    : value == 4
                    ? 'Canceled'
                    : '';
                },
              },
              'Net price (THB)': 'order_net_price',
              'Payment type': {
                field: 'order_payment_type',
                callback: (value) => {
                  return value == 5
                    ? 'QR code'
                    : value == 2
                    ? 'Credit/Debit Card'
                    : '';
                },
              },
              'Datetime order': 'create_at',
              'Datetime dine in': 'order_booking_datetime',
              'Store name': 'order_store.store_name',
              'Store Tel.': 'order_store.store_tel',
            }"
            :name="
              'OrderDineIn_' +
              $route.query.datetime_start +
              '_to_' +
              $route.query.datetime_end +
              '.csv'
            "
            style=""
          >
            <v-btn icon> <v-icon large color="black">print</v-icon>.csv </v-btn>
          </download-excel>
        </div>
        <!-- <v-btn
          :loading="isRequesting && RequestedTableFileType == 'csv'"
          :disabled="isRequesting"
          outline
          color="info"
          @click="requestTableFile('csv')"
          >request csv file</v-btn
        >
        <v-btn
          :loading="isRequesting && RequestedTableFileType == 'xlsx'"
          :disabled="isRequesting"
          outline
          color="info"
          @click="requestTableFile('xlsx')"
          >request xlsx file</v-btn
        > -->
      </v-flex>
    </v-layout>
    <v-layout
      v-if="isRequestedTableFile && dineinOrderReport.length > 0"
      wrap
      style="border: 2px solid grey; border-radius: 10px; padding: 10px"
    >
      <v-flex xs12 style="display: flex">
        <h3 style="color: grey" class="pl-2">Requested File List</h3>
        <v-spacer></v-spacer>
        <v-btn icon small @click="isRequestedTableFile = false"
          ><v-icon>close</v-icon></v-btn
        >
      </v-flex>
      <v-flex xs12 sm3 style="display: flex">
        <v-btn primary color="info" :href="fileData" target="_blank"
          >download {{ RequestedTableFileType }} file No.1</v-btn
        >
      </v-flex>
    </v-layout>
    <v-card style="border-radius: 10px; padding: 2.5px" class="mt-5">
      <v-data-table :headers="headers" :items="dineinOrderReport">
        <template slot="items" slot-scope="props">
          <tr style="background-color: #eeeeee">
            <td class="text-xs-left">{{ props.item.order_code }}</td>
            <td class="text-xs-left">
              {{ props.item.order_customer_full_name }}
            </td>

            <td class="text-xs-center">
              <span
                style="
                  border-radius: 6px;
                  padding: 0px 10px;
                  color: white;
                  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
                  white-space: nowrap;
                  font-weight: bold;
                "
                :style="{
                  backgroundColor:
                    props.item.order_status == 3
                      ? '#4bb543'
                      : props.item.order_status == 4
                      ? 'red'
                      : 'orange',
                }"
                >{{
                  props.item.order_status == 3
                    ? "Completed"
                    : props.item.order_status == 4
                    ? "Canceled"
                    : "On Process"
                }}</span
              >
            </td>
            <td class="text-xs-center">
              {{
                props.item.order_net_price
                  ? parseFloat(props.item.order_net_price).toFixed(2)
                  : "0.00"
              }}
            </td>
            <td class="text-xs-center">
              <v-icon
                medium
                :color="
                  props.item.order_is_paymented != 1 ||
                  props.item.order_payment_type == 2 ||
                  props.item.order_payment_type == 5
                    ? 'green'
                    : 'red'
                "
                >{{
                  props.item.order_payment_type == 1
                    ? "attach_money"
                    : props.item.order_payment_type == 2
                    ? "credit_card"
                    : props.item.order_payment_type == 3
                    ? "phone_iphone"
                    : props.item.order_payment_type == 4
                    ? "currency_exchange"
                    : props.item.order_payment_type == 5
                    ? "corporate_fare"
                    : ""
                }}</v-icon
              >
            </td>

            <td class="text-xs-center">
              {{ moment(props.item.create_at).format("YYYY-MM-DD HH:mm น.") }}
            </td>
            <td class="text-xs-center">
              {{
                moment
                  .utc(props.item.order_booking_datetime)
                  .format("YYYY-MM-DD HH:mm น.")
              }}
            </td>

            <td class="justify-center layout">
              <v-btn
                :to="`/weserve_admin_login/-/reportdashboard/main/dine-in-report/${props.item.order_id}`"
                color="primary"
                small
                slot="activator"
              >
                <span style="font-size: 12px; color: black; font-weight: bold">
                  View detail</span
                >
              </v-btn>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colspan="3">
              <b>ชื่อร้าน:</b>
              <b style="color: grey">
                {{ props.item.order_store.store_name }}</b
              >
            </td>
            <td colspan="3" class="text-xs-left">
              <b>เบอร์โทรร้าน: </b>
              <b style="color: grey"> {{ props.item.order_store.store_tel }}</b>
            </td>
            <td></td>
          </tr>
        </template>

        <template slot="no-data"></template>
      </v-data-table>
      <!-- <v-divider></v-divider> -->
      <!-- <div style="display: flex; align-items: center; justify-content: center">
        <div
          style="
            width: 50vw;
            display: flex;
            align-items: center;
            justify-content: center;
          "
          class="my-3"
        >
          <v-pagination
            class="mt-3"
            v-model="pagination.current_page"
            :length="pagination.page_length"
            @input="searchList()"
          ></v-pagination>
        </div>
      </div> -->
    </v-card>
  </div>
</template>

<script>
import internal from "stream";
import { mapState } from "vuex";

export default {
  data() {
    return {
      searching: false,
      valid: true,
      menu1: false,
      menu2: false,
      isRequestedTableFile: false,
      RequestedTableFileType: "",
      headers: [
        {
          text: "Order code",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Customer",
          value: "role",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          value: "status",
          sortable: false,
        },
        {
          text: "Net price",
          align: "center",
          value: "role",
          sortable: false,
        },
        {
          text: "Payment",
          align: "center",
          value: "role",
          sortable: false,
        },
        {
          text: "Date time order",
          align: "center",
          value: "role",
          sortable: false,
        },
        {
          text: "Date time dine in",
          align: "center",
          value: "role",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          value: "role",
          sortable: false,
        },
      ],
      columnItems: [
        {
          text: "Net price",
          value: "order_net_price",
          sortable: false,
          align: "center",
        },
      ],
      sortColumn: undefined,
      sortBy: undefined,
      form: { order_status: null, datetime_start: null, datetime_end: null },
      pagination: { page_size: 999, current_page: 1, total: 0, page_length: 0 },
      fileData: "",
      isRequesting: false,
    };
  },
  components: {},
  created() {
    if (this.dineinOrderReport.length > 0) {
      console.log(this.$route.query.sort_price);
      this.sortBy = this.$route.query.sort_price;
      this.pagination.page_size = this.$route.query.page_size;
      this.pagination.current_page = this.$route.query.current_page
        ? parseInt(this.$route.query.current_page)
        : 1;
      this.form.order_status = this.$route.query.order_status;
      this.form.datetime_start = this.$route.query.datetime_start;
      this.form.datetime_end = this.$route.query.datetime_end;
      this.pagination.total = this.$route.query.total;
      this.pagination.page_length = Math.ceil(
        this.pagination.total / this.pagination.page_size
      );
      this.sortColumn = this.$route.query.sort_column;
    } else {
      // this.$router.replace({ query: {} });
    }
  },
  destroyed() {
    this.$store.commit("report/resetState");
  },
  computed: {
    ...mapState({
      export_reward_format: (state) => state.report.export_reward_format,
      search_config: (state) => state.report.clone_config_path,
      dineinOrderReport: (state) => state.report.dineInReport.dineinOrderReport,
    }),
  },
  methods: {
    async search() {
      if (!this.$refs.searchForm.validate()) return;
      this.pagination.current_page = 1;
      this.searchList();
    },
    async searchList() {
      this.searching = true;
      let payload = {
        sort_price: this.sortBy,
        page_size: this.pagination.page_size,
        current_page: this.pagination.current_page,
        order_status: this.form.order_status,
        datetime_start: this.form.datetime_start,
        datetime_end: this.form.datetime_end,
      };
      let result = await this.$store.dispatch(
        "report/fetchReportDineIn",
        payload
      );
      this.searching = false;

      if (result == false) return;
      this.$router.replace({
        query: {},
      });
      this.pagination.total = result.data.total;
      this.pagination.page_length = Math.ceil(
        result.data.total / this.pagination.page_size
      );
      const mergedParams = {
        ...payload,
        total: this.pagination.total,
        sort_column: this.sortColumn,
      };
      this.$router.push({
        query: mergedParams,
      });
    },
    async letSortBy() {
      if (this.sortColumn == undefined) {
        this.sortBy = undefined;
      } else {
        this.sortBy = "asc";
      }

      this.searchList();
    },
    async requestTableFile(fileType) {
      this.isRequesting = true;
      this.RequestedTableFileType = fileType;
      let payload = {
        sort_price: this.sortBy,
        page_size: this.pagination.page_size,
        current_page: this.pagination.current_page,
        order_status: this.form.order_status,
        datetime_start: this.form.datetime_start,
        datetime_end: this.form.datetime_end,
        filename: fileType,
      };
      let result = await this.$store.dispatch(
        "report/requestedFileReportDineIn",
        payload
      );
      this.isRequesting = false;
      if (result == false) return;
      console.log(result);
      this.isRequestedTableFile = true;
      this.fileData = result.data;
    },
    selectAscDesc(value) {
      this.sortBy = value;
      this.searchList();
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Reward report",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}

.search-btn {
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
  padding: 0 10px;
  cursor: pointer;
}

.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
</style>
